/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Header extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-9-et block-4 z-21">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-62 ls-3 white-text bold-text text-uppercase mb0">How it<br/><span className="f-100 ls-6">Works</span> </h1>
                                <p className="white-text f-16 pb-8">UPON ARRIVAL, YOU WILL HAVE A GROUP OF ELITE ENTREPRENEURS <br className="hide-on-small-only"/> TOTALLY FOCUSED ON EXCHANGING VALUE AND <br className="hide-on-small-only"/> BUILDING REAL RELATIONSHIPS.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-12-et white-border-top">
                    <div className="p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 m8 offset-m2 l3">
                                <div className="col s12">
                                    <div className="row mb0 gradiant-bg-blue grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">GENERAL ADMISSION</p>
                                            <p className="white-text f-18">Full Access</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all p-20">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="col s12 center-align">
                                                    <p className="grey-text f-14 text-uppercase">Workbook</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a href="http://www.fownders.co/mastermind-step-1" className="btn-large cta-org-blue waves-effect waves-light col s12">BUY TICKET</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col s12 m8 offset-m2 l3 pb-20">
                                <div className="col s12">
                                    <div className="row mb0 gradiant-bg-org grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">VIP</p>
                                            <p className="white-text f-18">Exclusive Access</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Workbook</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Work out with Brian Mazza</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Priority Seating</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">VIP Lunch</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a href="http://www.fownders.co/mastermind-step-1" className="btn-large cta-org-blue waves-effect waves-light col s12">BUY TICKET</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col s12 m8 offset-m2 l3 pb-20">
                                <div className="col s12">
                                    <div className="row mb0 gradiant-bg-blue grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">VIP Platinum</p>
                                            <p className="white-text f-18">15 Ticket Group Package</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Workbook</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Work out with Brian Mazza</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Priority Seating</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">VIP Lunch</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Photographs</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a href="http://www.fownders.co/mastermind-package" className="btn-large cta-org-blue waves-effect waves-light col s12">BUY TICKET</a>
                                    </div>
                                </div>
                            </div>

                            <div className="col s12 m8 offset-m2 l3">
                                <div className="col s12">
                                    <div className="row mb0 gradiant-bg-org grey-border-all p-20">
                                        <div className="col s12 center-align">
                                            <p className="white-text f-22 bold-text text-uppercase">VIP PRIVATE</p>
                                            <p className="white-text f-18">30 Ticket Group Package</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 white grey-border-all">
                                        <div className="col s12 p0">
                                            <div className="white">
                                                <div className="row m0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Workbook</p>
                                                    </div>
                                                </div>
                                                <div className="row m0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Work out with Brian Mazza</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Priority Seating</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">VIP Lunch</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Photographs</p>
                                                    </div>
                                                </div>
                                                <div className="row mb0 white grey-border-bottom p-20">
                                                    <div className="col s12 center-align">
                                                        <p className="grey-text f-14 text-uppercase">Video for your business</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-20">
                                    <div className="col s12">
                                        <br/>
                                        <a href="http://www.fownders.co/mastermind-package" className="btn-large cta-org-blue waves-effect waves-light col s12">BUY TICKET</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default Header;


// WEBPACK FOOTER //
// ./src/components/pricing-section.js